// public/js/components/modal.js

export default function Modal(rootEl) {
  const closeButtons = rootEl.querySelectorAll('[data-action="close"]');
  const modalContent = rootEl.querySelector('[data-ref="content"]');
  const modalId = rootEl.id;

  if (!modalId) {
    console.warn('Modal: Component must have an ID', rootEl);
    return;
  }
  
  const toggleButtons = document.querySelectorAll(`[data-toggle="${modalId}"]`);

  let isOpen = false;
  let activeTrigger = null;
  let focusableEls = [];
  let firstFocusableEl = null;
  let lastFocusableEl = null;

  const updateFocusableElements = () => {
    const selector = 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const elements = Array.from(rootEl.querySelectorAll(selector));
    
    focusableEls = elements.filter(el => el.offsetParent !== null);
    firstFocusableEl = focusableEls[0];
    lastFocusableEl = focusableEls[focusableEls.length - 1];
  };

  const trapFocus = (e) => {
    if (focusableEls.length === 0) {
      e.preventDefault();
      return;
    }

    if (e.shiftKey) { 
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else { 
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  };

  const close = () => {
    isOpen = false;
    rootEl.classList.add('hidden');
    rootEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('keydown', handleDocumentKeydown);
    rootEl.removeEventListener('click', handleOutsideClick);

    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  };

  const open = (triggerBtn) => {
    isOpen = true;
    activeTrigger = triggerBtn;

    rootEl.classList.remove('hidden');
    rootEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    updateFocusableElements();

    document.addEventListener('keydown', handleDocumentKeydown);
    rootEl.addEventListener('click', handleOutsideClick);

    // Use requestAnimationFrame to wait for visibility before focusing
    requestAnimationFrame(() => {
      (firstFocusableEl ?? rootEl).focus();
    });
  };

  const toggle = (triggerBtn) => {
    if (isOpen) close();
    else open(triggerBtn);
  };

  const handleOutsideClick = (e) => {
    if (e.target === rootEl && !modalContent.contains(e.target)) {
      close();
    }
  };

  const handleDocumentKeydown = (e) => {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') trapFocus(e);
  };

  toggleButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggle(btn);
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      close();
    });
  });
}